import { escape } from 'lodash'
import he from 'he'

/**
 *
 * @param descriptionContent模板处理
 * @return {`content`}
 */
function contentTemplate(descriptionContent, column) {
  let content = ''
  if (!descriptionContent || !descriptionContent.length) {
    return
  }
  descriptionContent.forEach(item => {
    let itemContent = ''
    item.forEach(val => {
      // 宽度计算
      if (!val.span) {
        val.defaultWidth = Math.floor(10000 / column) / 100 + '%'
        // 若列数不满，最后一列补齐剩余宽度
        if (item.length < column) {
          item[item.length - 1].defaultWidth =
            100 - (Math.floor(10000 / column) / 100) * (item.length - 1) + '%'
        }
      } else {
        val.defaultWidth = Math.floor((10000 / column) * val.span) / 100 + '%'
        let spanTotal = 0
        for (let i = 0; i < item.length - 1; i++) {
          spanTotal += item[i].span
        }
        item[item.length - 1].defaultWidth =
          100 - Math.floor((10000 / column) * spanTotal) / 100 + '%'
      }

      // 样式设置
      const itemStyle = `width: ${
        val.width ? val.width : val.defaultWidth
      };margin-bottom: 10px;vertical-align: text-top;`
      const labelStyle = val.label ? 'color: #333;width: 50px;' : 'width: 0'
      const contentStyle = 'color: #444;width: 100%;text-align: left;'

      // content处理
      let contentStr = ''
      if (Array.isArray(val.content)) {
        val.content.forEach(contentItem => {
          if (contentItem?.content) {
            contentStr += `<div style="margin-bottom: 8px; ${contentItem.contentStyle ||
              ''}">${he.encode((contentItem.content || '').toString())}</div>`
          } else {
            contentStr += `<div style="margin-bottom: 8px">${he.encode(
              (contentItem || '').toString()
            )}</div>`
          }
        })
      } else {
        contentStr = he.encode((val.content || '').toString())
      }

      // 模板渲染
      itemContent += `
      <td style="${itemStyle}">
        <table style="width: 100%;height: 100%;vertical-align: text-top;">
          <td style="white-space: nowrap;${labelStyle};${val.labelStyle ||
        ''}">${(val.label || '').toString()}${val.label ? '：' : ''}</td>
          <td style="vertical-align: text-top;">
            <div style="${contentStyle};${val.contentStyle || ''}">
              ${contentStr}
            </div>
          </td>
        </table>
      </td>
      `
    })

    content += `<table style="width: 100%;"><tr>${itemContent}</tr></table>`
  })

  return content
}

/**
 *
 * @params descriptionContent为对象时处理方法
 */
function descriptionObjectHandle(descriptionContent) {
  let descriptionTitleString = ''
  let descriptionContentString = ''
  if (descriptionContent.descriptionTitle) {
    descriptionTitleString = descriptionTitleWrapper(
      descriptionContent.descriptionTitle
    )
  }
  if (!descriptionContent.column) {
    descriptionContent.column = 3
  }
  if (!descriptionContent.descriptionContent) {
    descriptionContentString = ''
  } else if (
    Object.prototype.toString.call(descriptionContent.descriptionContent) ===
    '[object String]'
  ) {
    descriptionContentString = descriptionContentWrapper(
      descriptionContent.descriptionContent
    )
  } else if (
    Object.prototype.toString.call(descriptionContent.descriptionContent) ===
    '[object Object]'
  ) {
    descriptionContentString = descriptionObjectHandle(
      descriptionContent.descriptionContent
    )
  } else if (
    Object.prototype.toString.call(descriptionContent.descriptionContent) ===
    '[object Array]'
  ) {
    descriptionContentString = descriptionArrayHandle(
      descriptionContent.descriptionContent,
      descriptionContent.column
    )
  }
  return `<div>${descriptionTitleString}${descriptionContentString}</div>`
}

/**
 *
 * @params descriptionContent为数组时处理方法，将数组变为二维数组
 */
function descriptionArrayHandle(descriptionContent, column) {
  let descriptionContentArr = []
  if (!descriptionContent || !descriptionContent.length) {
    return
  }
  let itemArr = []
  let spanTotal = 0
  for (let i = 0; i < descriptionContent.length; i++) {
    // 未设置span
    if (!descriptionContent[i].span && itemArr.length < column) {
      itemArr.push(descriptionContent[i])
      if (
        itemArr.length === column ||
        (i + 2 <= descriptionContent.length && descriptionContent[i + 1].span)
      ) {
        descriptionContentArr.push(itemArr)
        itemArr = []
      }
    }
    // 设置span
    if (descriptionContent[i].span) {
      if (descriptionContent[i].span > column) {
        descriptionContentArr = []
        return
      }
      // span占满一行
      if (descriptionContent[i].span === column) {
        itemArr.push(descriptionContent[i])
        descriptionContentArr.push(itemArr)
        itemArr = []
        spanTotal = 0
      }
      // span小于列
      if (spanTotal < column && descriptionContent[i].span < column) {
        spanTotal += descriptionContent[i].span

        if (spanTotal <= column) {
          itemArr.push(descriptionContent[i])

          if (
            i + 2 <= descriptionContent.length &&
            descriptionContent[i + 1].span + spanTotal > column
          ) {
            descriptionContentArr.push(itemArr)
            itemArr = []
            spanTotal = 0
          }
        }
        // 列数相加等于总列数或下一列为总列数或下一列不设置列数则spanTotal清空
        if (
          spanTotal == column ||
          (i + 2 <= descriptionContent.length &&
            descriptionContent[i + 1].span == column) ||
          (i + 2 <= descriptionContent.length &&
            !descriptionContent[i + 1].span)
        ) {
          descriptionContentArr.push(itemArr)
          itemArr = []
          spanTotal = 0
        }
      }
    }
  }
  descriptionContentArr.push(itemArr)

  return descriptionContentWrapper(descriptionContentArr, column)
}

/**
 *
 * @params content内容渲染
 */
function descriptionContentWrapper(descriptionContent, column) {
  if (Object.prototype.toString.call(descriptionContent) === '[object Array]') {
    const content = contentTemplate(descriptionContent, column)
    return `<div>${content}</div>`
  }
  if (
    Object.prototype.toString.call(descriptionContent) === '[object String]'
  ) {
    return descriptionContent
  }
}

/**
 *
 * @params pdf标题处理
 */
function pdfTitleWrapper(pdfTitle) {
  return `<h1 style="text-align: center;margin-bottom: 20px;">${escape(
    pdfTitle
  ) || ''}</h1>`
}

/**
 *
 * @params 用body包裹表格html字符串
 */
export function descriptionTitleWrapper(descriptionTitle) {
  return `<h3 style="text-align: left;${descriptionTitle.style ||
    ''};">${descriptionTitle.content || '-'}</h3>`
}

/**
 *
 * @param pdfTitle {String} pdf的标题
 * @param descriptionTitle {content：'', style: ''} 本段内容标题和标题样式，
 * @param column {number} 若descriptionContent为数组时，当前内容渲染的列数
 * @param descriptionContent 支持字符串、数组和对象三种参数传入，
 * 若为字符串则直接渲染
 * 若为数组表示正常的内容渲染，[{label, content, subContent， subContentStyle，span}]label：标题，labelStyle:标题样式， content：内容，contentStyle:内容样式， subContent：换行内容，subContentStyle: 换行内容样式，span: 占用当前列数的几列
 * 若为对象{descriptionContent, column，descriptionTitle} descriptionContent: 本段内容， column：本段内容列数，默认3列，descriptionTitle：本段标题
 * @returns {string}
 */
export function generateDescriptionHtml({
  pdfTitle = '',
  descriptionTitle,
  column = 3,
  descriptionContent
}) {
  const pdfTitleString = pdfTitleWrapper(pdfTitle)
  let descriptionTitleString = ''
  if (descriptionTitle) {
    descriptionTitleString = descriptionTitleWrapper(descriptionTitle)
  }
  let descriptionContentString = ''
  if (!descriptionContent || descriptionContent.length == 0) {
    descriptionContentString = ''
  } else if (
    Object.prototype.toString.call(descriptionContent) === '[object String]'
  ) {
    descriptionContentString = descriptionContentWrapper(descriptionContent)
  } else if (
    Object.prototype.toString.call(descriptionContent) === '[object Object]'
  ) {
    descriptionContentString = descriptionObjectHandle(descriptionContent)
  } else if (
    Object.prototype.toString.call(descriptionContent) === '[object Array]'
  ) {
    descriptionContentString = descriptionArrayHandle(
      descriptionContent,
      column
    )
  }
  return `<div>${pdfTitleString}${descriptionTitleString}${descriptionContentString}</div>`
}
